export default __webpack_public_path__ + "static/media/map.1bec2598.svg";